/**
 * A table id: a Discord Activity instance, a shared link's id or a local table. What
 * a missing value turns into ("undefined", "null", blank) is never one: in production
 * (13 Sept 2026) Discord sent `custom_id=undefined` and every such launch met on one
 * shared ghost table. The client and the server check the same rule.
 */
const TABLE_ID = /^[A-Za-z0-9][A-Za-z0-9._:-]{2,127}$/;
const MISSING = new Set(["undefined", "null"]);
export function isTableId(value) {
    return typeof value === "string" && TABLE_ID.test(value) && !MISSING.has(value);
}
//# sourceMappingURL=tableId.js.map